import type { Baum, BaumPlugin, BaumUi, BaumWorkspace } from "@gui-creator/gemeinsam";

export type Pfad = { plugin: BaumPlugin | null; workspace: BaumWorkspace | null; ui: BaumUi | null };

export function findePfad(baum: Baum, schluessel: { plugin?: string | undefined; workspace?: string | undefined; ui?: string | undefined }): Pfad {
  const plugin = baum.plugins.find((p) => p.schluessel === schluessel.plugin) ?? null;
  const workspace = plugin?.workspaces.find((w) => w.schluessel === schluessel.workspace) ?? null;
  const ui = workspace?.uis.find((u) => u.schluessel === schluessel.ui) ?? null;
  return { plugin, workspace, ui };
}

export function uiAdresse(plugin: string, workspace: string, ui: string): string {
  return `/p/${plugin}/${workspace}/${ui}`;
}

/** Findet zu einer UI-ID den Ort im Baum, etwa für Verweise. */
export function findeUi(baum: Baum, id: string): { plugin: BaumPlugin; workspace: BaumWorkspace; ui: BaumUi } | null {
  for (const plugin of baum.plugins) {
    for (const workspace of plugin.workspaces) {
      const ui = workspace.uis.find((u) => u.id === id);
      if (ui) return { plugin, workspace, ui };
    }
  }
  return null;
}
